<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formWalletManagement">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteWalletManagement()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="walletManagementContract.userNameCreate"
              [createDate]="walletManagementContract.createDate"
              [userNameUpdate]="walletManagementContract.userNameUpdate"
              [updateDate]="walletManagementContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-branchId">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [recovery]="true" [required]="true" (onChangeSelect)="changeBranch($event, true)"></app-custom-select>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive" [labelText]="'Código'" [required]="true"
                [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
            </div>
            <div class="col field-enterpriseId">
              <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                [required]="true"></app-custom-select>
            </div>
            <div class="col field-clientId">
              <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                [required]="true">
              </app-custom-autocomplete>
            </div>
            <div class="col field-contact">
              <app-custom-input-text formControlName="contact" [labelText]="'Contacto'" [required]="true"
                [maxLength]="50">
              </app-custom-input-text>
            </div>
            <div class="col field-dateWalletManagement">
              <app-custom-datetime-picker formControlName="dateWalletManagement" [labelText]="'Fecha'"
                [required]="true">
              </app-custom-datetime-picker>
            </div>
            <div class="col field-state">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateWalletManagement">
              </app-custom-tag>
            </div>
            <div class="col field-button-state">
              <app-custom-button [title]="titleState" [icon]="icon" [severity]="'primary'"
                (onClick)="changeStateWalletManagement()">
              </app-custom-button>
            </div>
            <div class="col field-observation">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1" [maxLength]="1000"></app-custom-textarea>
            </div>
            <div class="col field-buttons">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disableSendButton" (onClick)="send()">
              </app-custom-button>
              <app-custom-button [title]="'Contactos'" [label]="'Contactos'" [disabled]="disabledForm"
                (onClick)="openContactModal()"></app-custom-button>
              <app-custom-modal #clientContactModal [label]="'Contactos'" [header]="'Contactos'" [width]="'75vw'"
                [inputs$]="inputsForContactModals$" [children]="componentContactModal" hidden>
              </app-custom-modal>
              @if (walletManagementId && quantityDetails > 0) {
              <app-custom-button [title]="'Eliminar Cartera'" [label]="'Eliminar Cartera'" [severity]="'danger'"
                [width]="'8rem'" [disabled]="disabledForm" (onClick)="deleteWalletManagementDetail()">
              </app-custom-button>
              } @else {
              <app-custom-button [title]="'Cargar Cartera'" [label]="'Cargar Cartera'" [severity]="'primary'"
                [width]="'8rem'" [disabled]="disabledForm" (onClick)="createWalletManagementDetail()">
              </app-custom-button>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <section class="row mt-2">
    <div class="container-style mx-0">
      <div class="col-lg-12">
        <app-custom-table [headers]="detailHeader" [data]="detailData"
          (onRecoverData)="getWalletManagementDetailsForCaptureTable()" (onPageChange)="onPageChange($event)">
        </app-custom-table>
      </div>
    </div>
  </section>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>